
import { ISchedulation } from '@/modules/workspace/Workspace'
import { defineComponent } from 'vue'
import { filterDefault } from '@/helpers/commons/filterHelper'
import { formatDate } from '@/helpers/commons/localeHelper'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Message from 'primevue/message'
import workspaceSchedulationOldSchedulationsTableDescriptor from './WorkspaceSchedulationOldSchedulationsTableDescriptor.json'

export default defineComponent({
    name: 'workspace-schedulation-old-schedulations-table',
    components: { Column, DataTable, Message },
    props: { propSchedulations: { type: Array } },
    data() {
        return {
            workspaceSchedulationOldSchedulationsTableDescriptor,
            schedulations: [] as ISchedulation[],
            filters: { global: [filterDefault] } as any,
            user: null as any
        }
    },
    watch: {
        propSchedulations() {
            this.loadSchedulations()
        }
    },
    created() {
        this.user = (this.$store.state as any).user
        this.loadSchedulations()
    },
    methods: {
        loadSchedulations() {
            this.schedulations = this.propSchedulations as ISchedulation[]
        },
        getFormattedDate(date: any, format: any) {
            return formatDate(date, format)
        },
        downloadSnapshot(schedulation: ISchedulation) {
            const url = process.env.VUE_APP_HOST_URL + `/knowage/servlet/AdapterHTTP?NEW_SESSION=TRUE&user_id=${this.user?.userUniqueIdentifier}&ACTION_NAME=GET_SNAPSHOT_CONTENT&SNAPSHOT_ID=${schedulation.id}&LIGHT_NAVIGATOR_DISABLED=TRUE&OBJECT_ID=${schedulation.biobjId}`
            window.open(url, '_blank')
        }
    }
})
